import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterFilled } from '@ant-design/icons';
import { Collapse } from 'antd';

import { copyDeep, getSafe } from '../../../../shared/utility';
import { MODEL_SELECTION_FILTERS } from '../../../../shared/const/Routes/statePaths';
import { getModelSelectionFilters } from '../../../../store/actions/jobConfiguration/jobConfiguration';
import FilterButton from '../../../../components/FilterButton/FilterButton';
import { FILTER_ACTIONS, FILTER_TYPES } from '../../../../shared/const/consts';
import LoadingOverlay from '../../../../components/UI/LoadingOverlay/LoadingOverlay';

import './FeaturesSelection.scss';

const FeaturesSelection = props => {
  const filterData = useSelector(state =>
    getSafe(MODEL_SELECTION_FILTERS, state)
  );
  const dispatch = useDispatch();
  const { subProject, setFilters } = props;
  const [items, setItems] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getModelSelectionFilters(subProject));
  }, []);

  useEffect(() => {
    if (filterData) {
      setIsLoading(false);
    }
  }, [filterData]);

  useEffect(() => {
    updateItems();
    setFilters({});
  }, [filterData]);

  const updateItems = () => {
    if (!filterData) {
      return;
    }
    let newItems = filterData.map((filterItem, index) => {
      return {
        key: index,
        label: filterItem.displayText,
        children: getChildren(filterItem, index),
      };
    });
    setItems(newItems);
  };

  const onInclude = (value, index) => {
    setFilters(prevFilters => {
      let filterField = filterData[index].filterField;
      let tempFilters = copyDeep(prevFilters);
      if (!(filterField in tempFilters)) {
        tempFilters[filterField] = {};
      }
      tempFilters[filterField][value] = FILTER_ACTIONS.INCLUDE;
      return tempFilters;
    });
  };

  const onExclude = (value, index) => {
    setFilters(prevFilters => {
      let filterField = filterData[index].filterField;
      let tempFilters = copyDeep(prevFilters);
      if (!(filterField in tempFilters)) {
        tempFilters[filterField] = {};
      }
      tempFilters[filterField][value] = FILTER_ACTIONS.EXCLUDE;
      return tempFilters;
    });
  };

  const onResetFilter = (value, index) => {
    setFilters(prevFilters => {
      let filterField = filterData[index].filterField;
      let tempFilters = copyDeep(prevFilters);
      if (!(filterField in tempFilters)) {
        return prevFilters;
      }
      if (!(value in tempFilters[filterField])) {
        return prevFilters;
      }
      delete tempFilters[filterField][value];
      return tempFilters;
    });
  };

  const getChildren = (filterItem, index) => {
    return (
      <div className="filter-collapse-content-wrapper">
        {filterItem.values.map((value, key) => {
          return (
            <FilterButton
              key={key}
              value={value}
              filterIndex={index}
              isThreeState={filterItem.type == FILTER_TYPES.EXCLUDE}
              onInclude={onInclude}
              onExclude={onExclude}
              onNoFilter={onResetFilter}
            />
          );
        })}
      </div>
    );
  };

  return (
    <LoadingOverlay loading={isLoading}>
      <div className="filter-panel-wrapper">
        <div className="filter-panel-header">
          <FilterFilled className="filter-panel-icon" />
          <label className="filter-panel-title">Filter Panel</label>
        </div>
        <div className="filter-panel-content">
          {items
            ? items.map((item, index) => {
                return (
                  <Collapse
                    key={index}
                    className="filter-panel-collapse"
                    // defaultActiveKey={['0']}
                    // onChange={onChange}
                    expandIconPosition="end"
                    items={[item]}
                  />
                );
              })
            : null}
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default FeaturesSelection;
